<template>
  <div>
    <div class="min-vh-100">
      <CRow class="no-gutters px-3 px-sm-0">
        <b-col sm="6" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">ข้อมูล USER ID</h1>
        </b-col>
      </CRow>

      <div class="mt-3 bg-white-border p-3">
        <b-row v-if="isLoadingData">
          <b-col class="px-4 px-sm-5 py-4 vh-100">
            <img src="/img/loading.svg" class="loading" alt="loading" />
          </b-col>
        </b-row>
        <div>
          <b-row class="my-4">
            <b-col class="d-flex justify-content-end">
              <div v-if="id !== '0'">
                Register Date/Time
                {{ new Date(form.createdTime) | moment($formatDateTime) }}
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <InputText
                textFloat="First Name"
                placeholder="First Name"
                type="text"
                name="firstname"
                isRequired
                v-model="form.firstname"
                :isValidate="$v.form.firstname.$error"
                :v="$v.form.firstname"
              />
            </b-col>
            <b-col md="6">
              <InputText
                textFloat="Last Name"
                placeholder="Last Name"
                type="text"
                name="lastname"
                isRequired
                v-model="form.lastname"
                :isValidate="$v.form.lastname.$error"
                :v="$v.form.lastname"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <InputText
                textFloat="User Id"
                placeholder="User Id"
                type="text"
                name="userId"
                isRequired
                v-model="form.staffId"
                :isValidate="$v.form.staffId.$error"
                :v="$v.form.staffId"
              />
            </b-col>
            <b-col md="6">
              <InputText
                textFloat="Username"
                placeholder="Username"
                type="text"
                name="username"
                isRequired
                v-model="form.username"
                :isValidate="$v.form.username.$error"
                :v="$v.form.username"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" v-if="!isDisplayPassword">
              <InputText
                textFloat="Password"
                placeholder="Password"
                type="password"
                name="password"
                textWarning="(รหัสผ่านจำเป็นจะต้องมีตัวเลขและตัวอักษรรวมกันอย่างน้อย 8 ตัว เพื่อความปลอดภัย)"
                isRequired
                :disabled="id !== '0'"
                v-model="form.password"
                :isValidate="$v.form.password.$error"
                :v="$v.form.password"
              />
            </b-col>
            <b-col md="6" v-else-if="isDisplayPassword">
              <InputText
                textFloat="Password"
                placeholder="Password"
                type="password"
                name="password"
                textWarning="(รหัสผ่านจำเป็นจะต้องมีตัวเลขและตัวอักษรรวมกันอย่างน้อย 8 ตัว เพื่อความปลอดภัย)"
                isRequired
                :disabled="true"
                v-model="displayPassword"
              />
            </b-col>
            <b-col md="6" class="mt-md-4" v-if="id !== '0'">
              <button
                type="button"
                @click="$refs.modalResetPassword.show()"
                class="btn btn-reset-password text-uppercase"
              >
                Reset Password
              </button>
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col>
              <label class="font-weight-bold main-label">
                สถานะการแสดงผล
                <span class="text-danger">*</span>
              </label>
              <div>
                <b-form-checkbox
                  switch
                  v-model="form.active"
                  class="radio-active"
                  size="lg"
                >
                  <span class="ml-2 main-label">{{
                    form.active ? "Active" : "Disabled"
                  }}</span>
                </b-form-checkbox>
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-5">
            <b-col md="6">
              <b-button
                :disabled="isDisable"
                @click="cancleHandler"
                class="btn-details-set btn-cancel"
                >CANCEL</b-button
              >
            </b-col>
            <b-col md="6" class="text-sm-right">
              <button
                type="button"
                @click="checkForm()"
                :disabled="isDisable"
                class="btn btn-main btn-details-set ml-md-2 text-uppercase"
              >
                SAVE
              </button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
    <ModalResetPassword
      ref="modalResetPassword"
      :userData="form"
      :setNewPassword="setNewPassword"
    />
  </div>
</template>

<script>
import {
  required,
  integer,
  minLength,
  requiredIf,
  email,
  helpers,
  alphaNum,
} from "vuelidate/lib/validators";

const password = helpers.regex(
  "password",
  /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!-_]+)$/
);

const alpha = helpers.regex("alpha", /^[\u0E00-\u0E7Fa-zA-Z']*$/);

import InputText from "@/components/inputs/InputText";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalResetPassword from "./component/ModalResetPassword.vue";
export default {
  components: {
    InputText,
    ModalAlert,
    ModalAlertError,
    ModalLoading,
    ModalResetPassword,
  },
  data() {
    return {
      isLoadingData: false,
      modalMessage: "",
      isDisable: false,
      id: this.$route.params.id,
      redirecId: 0,
      isEditPassword: false,
      isDisplayPassword: false,
      displayPassword: "TESTPASSWORD001",
      form: {
        brandId: this.$route.query.brandID,
        userGUID: "",
        username: "",
        firstname: "",
        lastname: "",
        staffId: "",
        active: false,
        password: "",
      },
    };
  },
  validations: {
    form: {
      firstname: { required, alpha },
      lastname: { required, alpha },
      username: { required },
      staffId: { required, alphaNum },
      password: {
        required: requiredIf(function () {
          return this.id == 0;
        }),
        password,
        minLength: minLength(8),
      },
    },
  },
  created: async function () {
    this.getDatas();
  },
  methods: {
    isAlphabet: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 65 && charCode < 91) {
        return true;
      } else if (charCode > 96 && charCode < 123) {
        return true;
      } else if (charCode > 160 && charCode < 238) {
        return true;
      } else {
        evt.preventDefault();
      }
      // if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      //   evt.preventDefault();
      // } else {
      //   return true;
      // }
    },
    hadleModalAlertClose() {
      if (this.id == "0") {
        this.$router.push({ path: `/user/details/${this.redirecId}`, query: { brandID: this.$route.query.brandID } });
      } else {
        this.getDatas();
      }
    },
    setNewPassword(newPassword) {
      this.form.password = newPassword;
      this.isEditPassword = true;
    },
    cancleHandler() {
      this.$router.push({ name: "USER LIST", query: { brandID: this.$route.query.brandID } });
    },
    getDatas: async function () {
      if (this.id !== "0") {
        this.isLoadingData = true;
        await this.axios
          .get(`${this.$baseUrl}/user/${this.id}`)
          .then((data) => {
            if (data.result == 1) {
              this.form = data.detail;
              this.isDisplayPassword = true;
              this.isLoadingData = false;
            }
          });
      } else {
        this.isEditPassword = true;
      }
    },
    checkForm: async function () {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }

      if (!this.isEditPassword) {
        this.form.password = null;
      }
      this.submit();
    },
    submit: async function () {
      this.isDisable = true;
      this.$refs.modalLoading.show();
      await this.axios
        .post(`${this.$baseUrl}/user/save`, this.form)
        .then((data) => {
          if (data.result == 1) {
            this.redirecId = data.detail.userGUID;
            this.modalMessage = "สำเร็จ";
            this.$refs.modalLoading.hide();
            this.$refs.modalAlert.show();
            this.isEditPassword = false;
          } else {
            this.modalMessage = data.message;
            this.$refs.modalLoading.hide();
            this.$refs.modalAlertError.show();
          }
          this.isDisable = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-reset-password {
  background-color: #7160c4;
  color: white;
}
</style>
